import { render, staticRenderFns } from "./pointsRedemptionCoupon.vue?vue&type=template&id=24496faa&scoped=true"
import script from "./pointsRedemptionCoupon.vue?vue&type=script&lang=js"
export * from "./pointsRedemptionCoupon.vue?vue&type=script&lang=js"
import style0 from "./pointsRedemptionCoupon.vue?vue&type=style&index=0&id=24496faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24496faa",
  null
  
)

export default component.exports